import { AssistantsEndpoints, assistantsFetchJson } from './assistantsApiClient';

/**
 * @returns {Promise<Array<Record<string, unknown>>>}
 */
export async function getCompetitors() {
  const data = await assistantsFetchJson(AssistantsEndpoints.COMPETITORS);
  return data.competitors || [];
}
